import { render, staticRenderFns } from "./aboutMembers.vue?vue&type=template&id=e658732a&scoped=true&"
import script from "./aboutMembers.vue?vue&type=script&lang=js&"
export * from "./aboutMembers.vue?vue&type=script&lang=js&"
import style0 from "./aboutMembers.vue?vue&type=style&index=0&id=e658732a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e658732a",
  null
  
)

export default component.exports